import type { EntryPoint } from '#packages/apilib';
import { ComponentsApiKey, EditorAPIKey } from '#packages/apis';
import { createFeedbackApi } from './feedbackApi';
import { FeedbackApiKey } from './publicApiKey';

export const FeedbackEntrypoint: EntryPoint = {
  name: 'FeedbackApi',
  declareAPIs: () => [FeedbackApiKey],
  getDependencyAPIs: () => [EditorAPIKey, ComponentsApiKey, EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(FeedbackApiKey, () => createFeedbackApi(shell));
  },
};
